import clsx from "clsx";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { isString } from "util";

const getEnvironmentalPermitDate = (designation: SingleDesignation) => {
  const attribute = designation.designation_attributes.find((a) => a.key === "application_submission_date");

  if (!attribute?.value) {
    return null;
  }

  return new Date(attribute.value).toLocaleDateString();
};

const getDate = (designation: SingleDesignation) => {
  switch (designation.sub_category_id) {
    case "environmental_permits_approved":
    case "environmental_permits_pending":
    case "environmental_permits_withdrawn":
    case "environmental_permits_rejected":
    case "environmental_permits_unknown":
      return getEnvironmentalPermitDate(designation);
    default:
      return new Date(designation.source.adoption_date).toLocaleDateString();
  }
};

interface DesignationSubTitleProps {
  designation: SingleDesignation;
  truncate?: boolean;
}

export type DesignationSubTitleComponent = React.FC<DesignationSubTitleProps>;
export function DesignationSubTitle({ designation, truncate = false }: DesignationSubTitleProps) {
  const { t } = useTranslation();
  const categoryOrDefault = (designation: SingleDesignation) =>
    designation.sub_category?.display_name ?? t("domains.constraints.unknown");

  const date = getDate(designation);

  const value = [designation.display_name && categoryOrDefault(designation), designation.source.authority.name, date]
    .filter(isString)
    .join(", ");

  return (
    <div className={clsx("text-neutral-500", { truncate: truncate })} title={value}>
      {value}
    </div>
  );
}
